import { makeApiCall } from "../makeApiCall";
import { ReportService_URL } from "../Url";

////For Hourly Download
export const fetchHourlyCSVActions = {
  FETCH_PICKERREPORT_SUCCESS: "FETCH_PICKERREPORT_SUCCESS",
  FETCH_PICKERREPORT_FAILURE: "FETCH_PICKERREPORT_FAILURE",
  FETCH_CHECKEREPORT_SUCCESS: "FETCH_CHECKEREPORT_SUCCESS",
  FETCH_CHECKEREPORT_FAILURE: "FETCH_CHECKEREPORT_FAILURE",
};

///For the Pickers
export function fetchPickerReportError(error) {
  return {
    type: fetchHourlyCSVActions.FETCH_PICKERREPORT_FAILURE,
    payload: error,
  };
}
export function fetchPickerReportSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: fetchHourlyCSVActions.FETCH_PICKERREPORT_SUCCESS,
      payload: props,
    });
  };
}
export function fetchPickerReport(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${ReportService_URL}fetchHourlyCheckerAndPickerDetailsStats?startSearchDate=${props.fromDate}&endSearchDate=${props.toDate}&isPicker=${props.isPicker}&warehouseId=${props.warehouseId}`;
  // const getUrl = `https://e1afcfed-3472-4893-8c36-f33890c56755.mock.pstmn.io/fetchHourlyCheckerAndPickerDetailsStats?startSearchDate=${props.fromDate}&endSearchDate=${props.toDate}&isPicker=${props.isPicker}`;
  return makeApiCall(
    getUrl,
    fetchPickerReportSuccess,
    fetchPickerReportError,
    "GET",
    props.body,
    reqHeader,
    props.history
  );
}

///For the Checkers
export function fetchCheckerReportError(error) {
  return {
    type: fetchHourlyCSVActions.FETCH_CHECKEREPORT_FAILURE,
    payload: error,
  };
}
export function fetchCheckerReportSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: fetchHourlyCSVActions.FETCH_CHECKEREPORT_SUCCESS,
      payload: props,
    });
  };
}
export function fetchCheckerReport(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  // const getUrl = `${ReportService_URL}/fetchHourlyCheckerAndPickerDetailsStats?startSearchDate=${props.fromDate}&endSearchDate=${props.toDate}&isPicker=${props.isPicker}`;
  const getUrl = `https://e1afcfed-3472-4893-8c36-f33890c56755.mock.pstmn.io/fetchHourlyCheckerAndPickerDetailsStats?startSearchDate=${props.fromDate}&endSearchDate=${props.toDate}&isPicker=${props.isPicker}`;
  return makeApiCall(
    getUrl,
    fetchCheckerReportSuccess,
    fetchCheckerReportError,
    "GET",
    props.body,
    reqHeader,
    props.history
  );
}
